import React from "react";
import Dialog from "../../../components/Dialog/Dialog";
import { withStyles } from "@material-ui/core";
import CloseIcon from "../../../components/Icon/Close";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import Button from "../../../components/Button/Button";
import CheckMarkIcon from "../../../components/Icon/CheckMarkIcon";

const ModalSelecionarExame = observer(
  ({ classes, open, onClose, exames, exameStore, agendamento }) => {

    const handleClickExame = (item, index) => {
      try {
        exameStore.changeDadosExame(item?.exameDasaTipo, "tipoExame");
        exameStore.changeDadosExame(
          agendamento?.profissionalSaude,
          "profissionalSolicitante"
        );
        exameStore.changeDadosColeta({
          ...exameStore.dadosColeta,
          sujeitoAtencaoId: agendamento?.sujeitoAtencao?.id,
        });
        exameStore.agendamentoProcedimentoId = item?.agendamentoProcedimentoId
        exameStore.openModalExames = true;
        onClose()
      } catch (error) {
        console.error(error);
      }
    };

    return (
      <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
        <div className={classes.root}>
          <div className={classes.header}>
            <div className={classes.title}>Dados da coleta</div>
            <div id="pac-mse-btn-fch" onClick={onClose} className={classes.close}>
              <CloseIcon />
            </div>
          </div>

          <div className={classes.labelDescription}>Selecione o exame:</div>
          <div className={classes.content}>
            {exames?.map((item, index) => (
              
              <div className={classes.wrapperExameProcedimento}>
                <div className={classes.nomeExameButton}>
                   <span className={classes.labelExame}>Procedimento</span>
                  <span className={classes.nomeExame}>{item?.nomeProcedimento}</span>
                  <span className={classes.labelExame}>EXAME: {item?.exameDasaTipo?.descricao}</span>
                </div>
                <div>
                 { item.incluido ? (<div className={classes.incluido}>Incluido <CheckMarkIcon color={"#fff"}/></div>):(<Button
                    key={index}
                    className={classes.button}
                    onClick={() => handleClickExame(item, index)}
                  >Adicionar
                  </Button>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Dialog>
    );
  }
);

const styles = {
  paper: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    maxWidth: "500px",
    maxHeight: "430px",
    borderRadius: "12px",
  },

  root: {
    padding: 12,
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 10,
    borderBottom: "1px solid #e0e0e0",
  },

  title: {
    fontSize: 18,
    fontWeight: 600,
  },

  close: {
    cursor: "pointer",
  },

  wrapperExameProcedimento:{
    display: 'flex',
    alignItems: 'center',
    background: '#f2f2f2',
    padding: '12px',
    borderRadius: '8px'
  },

  button: {
    width: '103px',
    height: '30px',
    fontSize: '10px',
    textTransform: 'capitalize',
    padding: '20px',
    borderRadius: '20px'
  },

  incluido:{
    display: 'flex',
    gap: '5px',
    padding: '8px',
    borderRadius: '25px',
    color: '#ffffff',
    background: '#63AEAC'
  },

  content: {
    gap: "10px",
    display: "flex",
    marginTop: "10px",
    overflowY: "auto",
    flexDirection: "column",
    padding: "5px",
    flexShrink: "0",
    height: "calc( 100% - 120px )",
  },

  item: {
    cursor: "pointer",
    border: "1px solid #5050502e",
    backgroundColor: "#f2f2f2",
    color: "#333333",
    borderRadius: "8px",
    fontWeight: "400",
    padding: "12px 16px",
    fontSize: "14px",
    textAlign: "left",
    minHeight: "70px",
    "&:hover": {
      backgroundColor: "#e6e6e6",
      borderColor: "#0a0a0a2e",
    },
    WebkitTransition: "all 0.2s ease-in-out",
    transition: "all 0.2s ease-in-out",
  },

  label: {
    fontSize: 12,
    fontWeight: 600,
    color: "#666",
  },

  nomeProcedimento: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 6,
    color: "#222",
  },

  labelExame: {
    fontSize: 12,
    fontWeight: 600,
    color: "#666",
    marginTop: 6,
  },

  examesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    marginTop: 2,
  },

  nomeExame: {
    fontSize: 13,
    color: "#444",
  },

  labelDescription: {
    display: "flex",
    fontSize: "16px",
    padding: "5px",
    color: "#505050",
  },

  nomeExameButton: {
    display: "flex",
    flexDirection: "column",
    minHeight: "70px",
    width: "100%",
  },
};

const ModalSelecionarExameWithStyles = withStyles(styles)(ModalSelecionarExame);
export default inject("exameStore")(ModalSelecionarExameWithStyles);
